export default __webpack_public_path__ + "static/media/bg.69b92f07.jpg";